import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Filter } from 'lucide-react';
import { ParceiroFilters as ParceiroFiltersType } from '@/types/parceiros';

interface ParceiroFiltersProps {
  filters: ParceiroFiltersType;
  onFiltersChange: (filters: ParceiroFiltersType) => void;
}

export function ParceiroFilters({ filters, onFiltersChange }: ParceiroFiltersProps) {
  return (
    <Card className="border-dashed">
      <CardContent className="pt-6">
        <div className="flex items-center gap-2 mb-4">
          <Filter className="h-4 w-4 text-muted-foreground" />
          <h3 className="font-semibold text-sm">Filtros</h3>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Filtro por Período */}
          <div className="space-y-2">
            <Label htmlFor="periodo" className="text-xs">Período</Label>
            <Select
              value={filters.periodo || 'todos'}
              onValueChange={(value) => onFiltersChange({ 
                ...filters, 
                periodo: value as ParceiroFiltersType['periodo']
              })}
            >
              <SelectTrigger id="periodo" className="h-9">
                <SelectValue placeholder="Selecione..." />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="todos">Todos os períodos</SelectItem>
                <SelectItem value="7_dias">Últimos 7 dias</SelectItem>
                <SelectItem value="30_dias">Últimos 30 dias</SelectItem>
                <SelectItem value="90_dias">Últimos 90 dias</SelectItem>
                <SelectItem value="12_meses">Últimos 12 meses</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Filtro por Status */}
          <div className="space-y-2">
            <Label htmlFor="status" className="text-xs">Status</Label>
            <Select
              value={filters.status || 'todos'}
              onValueChange={(value) => onFiltersChange({ 
                ...filters, 
                status: value as ParceiroFiltersType['status']
              })}
            >
              <SelectTrigger id="status" className="h-9">
                <SelectValue placeholder="Selecione..." />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="todos">Todos</SelectItem>
                <SelectItem value="ativo">Ativos</SelectItem>
                <SelectItem value="inativo">Inativos</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Ordenação */}
          <div className="space-y-2">
            <Label htmlFor="ordenacao" className="text-xs">Ordenar por</Label>
            <Select
              value={filters.ordenacao || 'valor_contratos'}
              onValueChange={(value) => onFiltersChange({ 
                ...filters, 
                ordenacao: value as ParceiroFiltersType['ordenacao']
              })}
            >
              <SelectTrigger id="ordenacao" className="h-9">
                <SelectValue placeholder="Selecione..." />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="valor_contratos">Maior valor em contratos</SelectItem>
                <SelectItem value="total_leads">Mais leads</SelectItem>
                <SelectItem value="taxa_conversao">Maior taxa de conversão</SelectItem>
                <SelectItem value="nome">Nome (A-Z)</SelectItem>
                <SelectItem value="data_inicio">Mais recente</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}


